<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="modal-message" [innerHTML]="message"></div>
  <iframe frameborder="0" loading="lazy" class="video-preview" *ngIf="videoURL" [src]="videoURL" tabindex="0"></iframe>

  <div class="additional-info" *ngIf="showAdditionalInfo">
    <div class="info-icon">
      <span class="material-icons icon icon-small" aria-hidden="true">error</span>
    </div>
    Find comprehensive details on the evaluation process under the “info” icon.
  </div>
  
</div>


<div class="modal-footer">
  <button
    *ngIf="btnCancelText"
    type="button"
    class="button button-secondary"
    (click)="decline()"
  >
    {{ btnCancelText }}
  </button>
  <button
    [ngClass]="{ 'ml-24': btnCancelText !== undefined }"
    type="button"
    class="button button-primary"
    (click)="accept()"
  >
    {{ btnOkText }}
  </button>
</div>
